import { render, staticRenderFns } from "./OverviewForm.vue?vue&type=template&id=73dc39f5"
import script from "./OverviewForm.vue?vue&type=script&lang=js"
export * from "./OverviewForm.vue?vue&type=script&lang=js"
import style0 from "./OverviewForm.vue?vue&type=style&index=0&id=73dc39f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports